import { render, staticRenderFns } from "./CopyrightLine.vue?vue&type=template&id=527b6c0a&scoped=true&"
import script from "./CopyrightLine.vue?vue&type=script&lang=js&"
export * from "./CopyrightLine.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightLine.vue?vue&type=style&index=0&id=527b6c0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527b6c0a",
  null
  
)

export default component.exports